// 存放一些常量
export const THIS_YEAR = 2023;
export const achievementsID = 20;
export const totleDataSourceNum = 20
export const keywordID = 21